import { z } from "zod";
import { schemes } from "../../schema-validation";

const usageLogQueryOpts = z.object({
  companyID: z.string(),
  policyID: z.array(schemes.mongoObjectId()),
  employeeID: z.array(schemes.mongoObjectId()),
  reportingPeriodID: z.array(schemes.mongoObjectId()),
});

export type UsageLogQueryOpts = z.infer<typeof usageLogQueryOpts>;

const usageLogAggregateOutputSchema = z.object({
  policyID: schemes.mongoObjectId(),
  employeeID: schemes.mongoObjectId(),
  reportingPeriodID: schemes.mongoObjectId(),
  amount: z.number(),
});

const usageLogYTDAggregateOutputSchema = usageLogAggregateOutputSchema.pick({
  employeeID: true,
  policyID: true,
  amount: true,
});

export type UsageLogAggregateOutput = z.infer<
  typeof usageLogAggregateOutputSchema
>;

export type UsageLogYTDAggregateOutput = z.infer<
  typeof usageLogYTDAggregateOutputSchema
>;

const employeeUsageLogMapSchema = z.record(
  // employeeID
  z.string(),
  z.record(
    z.string(),
    // policyID
    z.object({
      total: z.number(),
      reportingPeriods: z.record(
        z.string(),
        usageLogAggregateOutputSchema
          .omit({
            employeeID: true,
            reportingPeriodID: true,
            policyID: true,
          })
          .merge(z.object({ ytd_usage: z.number() }))
      ),
    })
  )
);

export type EmployeeUsageLogMap = z.infer<typeof employeeUsageLogMapSchema>;
